import {createReducer, on} from '@ngrx/store';
import * as FeatureFlagsActions from './featureFlags.actions';
import {initialState} from './featureFlags.state';

export const featureFlagsReducer = createReducer(
  initialState, 
  on(FeatureFlagsActions.setFeatureFlags,(state, { profile }) => ({
    ...state,
    profile: profile
  })),
  on(FeatureFlagsActions.reset, () => initialState)
);
